import { getProductCategories } from "@hardware/Services/CustomProductService";
import { setGA4Event } from "@hardware/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const { qtyOrdered } = props.apiParameter;

    const result = await getProductCategories({
        productIds: [props.apiParameter.productId],
        type: "product",
    });

    if (result.successful) {
        const { categories, brandName: brand, categoriesIds } = result.result.productProperties[0];
        const categoriesToArr = Object.values(categoriesIds);
        const pageCategoryId = categoriesToArr[categoriesToArr.length - 1] || "";

        // TODO: Ask BE to send the categories IDs as well
        setGA4Event("add_to_cart", [props.apiResult], { categories, brand, pageCategoryId, qtyOrdered });
    }
});
